import { Squish } from '@grubhubprod/gh-cookbook-react';
import React, { ReactNode } from 'react';
import { PageSection } from 'src/components/selfService/layout/PageSection/PageSection';
import { IllustrationCard } from './IllustrationCard';

export interface IIllustrationCardWrapperProps {
  illustration: ReactNode;
  action: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
}

export function IllustrationCardWrapper({
  illustration,
  action,
  title,
  description,
}: IIllustrationCardWrapperProps): JSX.Element {
  return (
    <PageSection bg="globals.white">
      <Squish inset="md">
        <IllustrationCard
          illustration={illustration}
          action={action}
          title={title}
          description={description}
        />
      </Squish>
    </PageSection>
  );
}
